// extracted by mini-css-extract-plugin
export default {"available":"day-picker_available__fC+lE","disabled":"day-picker_disabled__wCyX6","selected":"day-picker_selected__63GJp"};